import { List } from '../components/List/List';

export const MainPage = () => {
  return <List />;
};
